import { render } from "./CustomValidationRules.vue?vue&type=template&id=f53c3d88"
import script from "./CustomValidationRules.vue?vue&type=script&lang=js"
export * from "./CustomValidationRules.vue?vue&type=script&lang=js"
script.render = render

export default script